import axios from 'axios'

export default {
    get(token) {
        return axios.get(`/mcard/share/${token}`)
    },

    getPdf(token) {
        return axios.get(`/mcard/share/${token}/pdf`, { responseType: 'blob' })
    },
}
